import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      "Consumers": "Consumers",
      "Agents": "Agents",
      "Login" : "Login",
      "Logout": "Logout"
    }
  },
  es: {
    translation: {
        "Consumers": "Consumidores",
        "Agents": "Agentes",
        "Login" : "Iniciar sesión",
        "Logout": "Cerrar sesión"
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", 
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;